import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getGalleryApi,
  createGalleryApi,
  deleteGalleryApi,
} from "./galleryApi";

// GET
export const getGallery = createAsyncThunk(
  "gallery/getGallery",
  async ({ page, limit }, thunkAPI) => {
    try {
      const res = await getGalleryApi({ page, limit });
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

// CREATE
export const createGallery = createAsyncThunk(
  "gallery/createGallery",
  async (data, thunkAPI) => {
    try {
      const res = await createGalleryApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

// DELETE
export const deleteGallery = createAsyncThunk(
  "gallery/deleteGallery",
  async (id, thunkAPI) => {
    try {
      const res = await deleteGalleryApi(id);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

const gallerySlice = createSlice({
  name: "gallery",
  initialState: {
    gallery: [],
    total: 0,
    loading: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGallery.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGallery.fulfilled, (state, action) => {
        state.loading = false;
        state.gallery = action.payload?.items || [];
        state.total = action.payload?.total || 0;
      })
      .addCase(getGallery.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default gallerySlice.reducer;